module.exports = __webpack_public_path__ + "141d4a85/img/search-filter-icon.c4751a52.svg";